module.exports = __webpack_public_path__ + "img/legal_default_pc.221a53e.jpg";